import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { apiPostVoid } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

export function useEndMeeting(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiPostVoid(`/meetings/${meetingId}/end`),
    onSuccess: () => {
      toast.success('Встреча завершена')
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: () => toast.error('Не удалось завершить встречу'),
  })
}

export function useCancelMeeting(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiPostVoid(`/meetings/${meetingId}/cancel`),
    onSuccess: () => {
      toast.success('Встреча отменена')
      void qc.invalidateQueries({ queryKey: meetingKeys.detail(meetingId) })
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: () => toast.error('Не удалось отменить встречу'),
  })
}
